import { Table, TableBody } from '@mui/material'
import DenomRow from '../../../components/DenomRow'
import LoadingWrapper from '../../../components/LoadingWraper'
import { SectionWrapper } from '../../../components/tableComponents'
import { TOmniStarAccountBalanace } from '../../../types/cosmosApi'

type props = {
    balances?: TOmniStarAccountBalanace[],
    isLoading: boolean, 
    error: unknown | undefined,
    isSuccess: boolean
}

const BalancesSection = ({balances, isLoading, error, isSuccess} : props) => {
  return (
    <div>
        <h4>Balances:</h4>
        <LoadingWrapper
            child={
                <SectionWrapper>
                    <Table  aria-label="balances table">
                        <TableBody>
                            {balances?.map(
                                (b) => {
                                    return <DenomRow key={b.balance.denom+b.balance.amount} denom={b.balance.denom} amount={b.balance.amount} />
                                }
                            )}
                        </TableBody>
                    </Table>
                </SectionWrapper>
            }
            isLoading = {isLoading }
            error = {!!error}
            isSucceeded={isSuccess}
            errorTxt={`Could not found any balances`}
        />
    </div>
  )
}

export default BalancesSection